import React from 'react';
import proptypes from 'prop-types';
import { ThemeContext } from './ThemeContext';

const { node, func } = proptypes;

const ThemeProvider = ({ children, theme, ...props }) => {

  const value = {
    theme,
    props
  };
  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: node.isRequired,
  theme: func
};

ThemeProvider.defaultProps = {
  theme: null
};

ThemeProvider.displayName = 'ThemeProvider';

export { ThemeProvider };
